import systemPreferencesAPI from '@/api/systemPreferences'

const state = {
  savedFilters: [],
  preferredFilter: [],
  activeFilterName: '',
  activeFilterValue: null
}

const getters = {
  savedFilters: (state) => state.savedFilters,
  preferredFilter: (state) => state.preferredFilter,
  activeFilterName: (state) => state.activeFilterName,
  activeFilterValue: (state) => state.activeFilterValue
}

const mutations = {
  SET_FILTER_PREFERENCES (state, payload) { state.savedFilters = payload },
  SET_PREFERRED_FILTER (state, payload) { state.preferredFilter = payload },
  SET_ACTIVE_FILTER_NAME (state, payload) { state.activeFilterName = payload },
  SET_ACTIVE_FILTER_VALUE (state, payload) { state.activeFilterValue = payload }
}

const actions = {
  getAllSavedFilters ({ commit }) {
    return systemPreferencesAPI.getAllSavedFilters().then(preferences => {
      let savedFilters = preferences.data.map(p => p.attributes)
      commit('SET_FILTER_PREFERENCES', savedFilters)
      let preferredFilter = savedFilters.filter(filter => filter.preferred === true)
      commit('SET_PREFERRED_FILTER', preferredFilter)
    })
  },
  setActiveFilter ({ commit }, { name, value }) {
    commit('SET_ACTIVE_FILTER_NAME', name)
    commit('SET_ACTIVE_FILTER_VALUE', value)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
